import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { LabelDimensions, PrinterListItem, PrinterStatus } from '../models';
import { LabelDimensionsDto } from '../models/label-dimensions.dto';
import { PrinterListItemDto } from '../models/printer-list-item.dto';
import { PrinterStatusDto } from '../models/printer-status.dto';

@Service()
export class HttpService {
    private httpClient = inject(HttpClient);

    getPrinters(): Observable<PrinterListItem[]> {
        return this.httpClient
            .get<ApiResponse<PrinterListItemDto[]>>('printers')
            .pipe(mapDto((response) => response.data.map((dto) => new PrinterListItem(dto))));
    }

    getLabelDimensions(): Observable<LabelDimensions[]> {
        return this.httpClient
            .get<ApiResponse<LabelDimensionsDto[]>>('printers/label-dimensions')
            .pipe(mapDto((response) => response.data.map((dto) => new LabelDimensions(dto))));
    }

    // Unreachable is a normal row state here, so this opts out of the error toast.
    getPrinterStatus(id: string): Observable<PrinterStatus> {
        return this.httpClient
            .skipErrorMessageInterceptor()
            .get<ApiResponse<PrinterStatusDto>>(`printers/${id}/status`)
            .pipe(mapDto((response) => new PrinterStatus(response.data)));
    }
}
